import { Box, IconButton, Theme, Typography, useMediaQuery } from '@mui/material';
import { useTranslation } from 'next-i18next';
import Image from 'next/image';
import { useRouter } from 'next/router';
import { useEffect, useRef } from 'react';
const Custom_Story = {
  title: 'Custom Story',
  text: 'custom_story',
  value: 6,
  url: 'custom-story',
  bgcolor: '#FED9D1',
  color: '#B97B6E',
  content: 'custom_story',
};
const templates = [
  {
    title: 'Life Story',
    text: 'life_story',
    value: 0,
    url: 'life-story',
    content: 'life_story_content',
    bgcolor: '#FED9D1',
    color: '#B97B6E',
    icon: '/icons/lifeStory.svg',
    position: 'center',
  },
  {
    title: 'Wedding Story',
    text: 'wedding_story',
    value: 1,
    url: 'classmates-story',
    content: 'classmates_story_content',
    bgcolor: '#0072CE',
    color: '#D8E8F6',
    icon: '/icons/wedding.svg',
    position: 'right',
  },
  {
    title: 'Retirement Story',
    text: 'retirement_story',
    value: 2,
    url: 'teammates-story',
    content: 'teammates_story_content',
    bgcolor: '#89D3FF',
    color: '#0072CE',
    icon: '/icons/retirement.svg',
    position: 'left',
  },
  {
    title: 'Classmates Story',
    text: 'classmates_story',
    value: 3,
    bgcolor: '#F1E0FF',
    color: '#8C58B8',
    icon: '/icons/classmate.svg',
    position: 'center',
  },
  {
    title: 'Teammates Story',
    text: 'teammates_story',
    value: 4,
    bgcolor: '#FED9D1',
    color: '#B97B6E',
    icon: '/icons/teammate.svg',
    position: 'center',
  },
  {
    title: 'Tribute Story',
    text: 'tribute_story',
    value: 5,
    bgcolor: '#0072CE',
    color: '#D8E8F6',
    icon: '/icons/tribute.svg',
    position: 'center',
  },
];
interface TypeStoryProps {
  handleBack?: () => void;
}

export const TypeStory = ({ handleBack }: TypeStoryProps) => {
  const { t } = useTranslation();
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));
  const router = useRouter();
  const outerBoxRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // Reset scroll position when modal opens
    window.scrollTo(0, 0);
    if (outerBoxRef.current) {
      outerBoxRef.current.scrollTop = 0;
      // Find and reset all scrollable parent containers
      let parent = outerBoxRef.current.parentElement;
      while (parent) {
        if (parent.scrollTop > 0) {
          parent.scrollTop = 0;
        }
        parent = parent.parentElement;
      }
    }
  }, []);

  const setStory = (item: any) => {
    router.push(`/app/story/create?mem=${item?.text}`);
  };

  const handleClose = () => {
    if (handleBack) handleBack();
    if (router.pathname !== '/app/collaborators') return router.push('/app/home');
  };

  return (
    <Box
      ref={outerBoxRef}
      sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        minHeight: '100dvh',
        background: 'rgba(0, 0, 0, 0.5)',
        zIndex: 1100,
      }}>
      <Box
        py={!isMobile ? '12rem' : '2rem'}
        sx={{
          width: '100%',
          minHeight: '100%',
          bgcolor: isMobile ? '#212d6dE5' : 'rgba(33, 45, 109, 0.5)',
          px: '1rem',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'left',
          alignItems: 'left',
          position: 'relative',
          textAlign: 'left',
        }}>
        <Box width={'100%'} justifyContent={'left'} maxWidth={'1110px'} margin={'0 auto'}>
          {/* Header Row */}
          <Box
            display='flex'
            justifyContent='space-between'
            alignItems='center'
            width='100%'
            paddingRight={isMobile ? 2 : 0}
            mb={3}
            sx={{ flexDirection: 'row' }}>
            {/* Left-side close button */}
            <IconButton
              onClick={handleClose}
              sx={{
                position: !isMobile ? 'absolute' : 'relative',
                top: !isMobile ? '2.5rem' : '0rem',
                color: 'white',
              }}>
              <Image priority src='/icons/close.svg' width={16} height={16} alt='close' />
            </IconButton>

            {/* Centered Title on Mobile */}
            <Box display='flex' alignItems='center' flexGrow={1} justifyContent={isMobile ? 'center' : 'flex-start'}>
              <Typography fontSize='1.3rem' color='#F1F7FA'>
                Create a Memvy
              </Typography>
            </Box>
          </Box>

          {/* Custom Story */}
          <Box
            px={isMobile ? 2 : 4}
            onClick={() => setStory(Custom_Story)}
            display='flex'
            alignItems='center'
            justifyContent='space-between'
            sx={{
              p: 3,
              borderRadius: '10px',
              width: '100%',
              maxWidth: '350px',
              height: '125px',
              background: 'linear-gradient(92.44deg, #0171CE 6.58%, #3E44C2 89.27%)',
              color: 'white',
              cursor: 'pointer',
              fontWeight: 400,
              margin: isMobile ? '0 auto' : '0',
              overflow: 'hidden',
            }}>
            <Typography align='left' lineHeight={'2rem'} fontSize={'1.6rem'}>
              Custom <br /> Story
            </Typography>
            <Image priority
              src={'/images/logo-light-blue.svg'}
              alt={'icon'}
              width={198}
              height={100}
              style={{ marginLeft: '60px' }}
            />
          </Box>

          <Typography
            fontSize={'0.9rem'}
            align={isMobile ? 'center' : 'left'}
            px={isMobile ? 0 : 0}
            sx={{ my: '29px', color: '#F1F7FA' }}>
            or use a template to get inspired
          </Typography>

          {/* Templates Grid */}
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: isMobile ? '1fr' : 'repeat(3, minmax(100px, 1fr))',
              gap: 4,
              justifyContent: 'center',
              alignItems: 'center',
            }}>
            {templates.map((item: any) => (
              <Box
                onClick={() => setStory(item)}
                key={item?.title}
                sx={{
                  p: 3,
                  borderRadius: '10px',
                  width: '100%',
                  maxWidth: '350px',

                  height: '125px',
                  textAlign: 'left',
                  background: item?.bgcolor,
                  backgroundImage: `url(${item?.icon})`,
                  backgroundSize: 'contain',
                  backgroundPosition: item?.position,
                  backgroundRepeat: 'no-repeat',
                  cursor: 'pointer',
                  fontWeight: 400,
                  margin: '0 auto',
                }}>
                <Typography lineHeight={'2rem'} fontSize={'1.6rem'} color={item?.color}>
                  {item?.title.split(' ').map((word: any, index: any) => (
                    <span key={index}>
                      {word}
                      <br />
                    </span>
                  ))}
                </Typography>
              </Box>
            ))}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
